import { render, staticRenderFns } from "./pageMagicSquareModule.vue?vue&type=template&id=dfe59b6c&scoped=true"
import script from "./pageMagicSquareModule.vue?vue&type=script&lang=js"
export * from "./pageMagicSquareModule.vue?vue&type=script&lang=js"
import style0 from "./pageMagicSquareModule.vue?vue&type=style&index=0&id=dfe59b6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe59b6c",
  null
  
)

export default component.exports